import React from 'react';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';

import Box, { type BoxProps } from '@mui/material/Box';

import { styledComponent } from 'src/utils/styled';
import Typography from 'src/components/ui/Typography';

type Props = {
    previousPageHref?: string;
    nextPageHref?: string;
    currentPage: number;
};

type NavBoxProps = BoxProps & {
    as?: string;
};
const NavBox = styledComponent(Box)<NavBoxProps>``;

export const AnchorPagination: React.FC<Props> = ({ previousPageHref, nextPageHref, currentPage }) => {
    const { t } = useTranslation('common');

    return (
        <>
            <Head>
                {previousPageHref && <link key="pagination-previous" rel="prev" href={previousPageHref} />}
                {nextPageHref && <link key="pagination-next" rel="next" href={nextPageHref} />}
            </Head>
            <NavBox as="nav" display="flex" gap="0.5rem" justifyContent="center" marginTop="1rem">
                {previousPageHref && (
                    <a href={previousPageHref} rel="prev">
                        {t('common:previous')}
                    </a>
                )}
                <Typography>{`${t('common:page')} ${currentPage}`}</Typography>
                {nextPageHref && (
                    <a href={nextPageHref} rel="next">
                        {t('common:next')}
                    </a>
                )}
            </NavBox>
        </>
    );
};
